<template>
  <div class="learning-areas-list">
    <router-link
      v-for="category in categoriesSliced"
      :key="category.id"
      :to="{ name: 'learning-area', params: { id: category.id } }"
      class="learning-areas-list__tile"
      :style="`background-image: url(${backgroundImg(category.name)})`"
    >
      <div class="learning-areas-list__overlay"></div>
      <div class="learning-areas-list__title-wrapper">
        <h6 class="learning-areas-list__title">{{ category.name }}</h6>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'LearningAreasList',
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  computed: {
    categoriesSliced() {
      return this.categories.slice(0, 6)
    },
  },
  methods: {
    backgroundImg(name) {
      const url =
        'https://s3.amazonaws.com/my.ine.com/assets/learning-areas/thumbs/'
      switch (name) {
        case 'DevOps':
          return `${url}devops_thumb.jpg`
        case 'Cloud':
          return `${url}devops_thumb.jpg`
        case 'Networking':
          return `${url}networking_thumb.jpg`
        case 'Development':
          return `${url}development_thumb.jpg`
        case 'Security':
          return `${url}security_thumb.jpg`
        case 'General IT':
          return `${url}general_thumb.jpg`
        case 'Data Science':
          return `${url}data_science_thumb.jpg`
        default:
          return `${url}devops_thumb.jpg`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.learning-areas-list {
  $this: &;
  color: var(--white);
  padding: 0 20px;
  margin: 0 0 50px 0;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr 1fr;
  grid-gap: 20px 20px;
  @include tablet {
    -ms-grid-columns: 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
  }
  @include desktop {
    padding: 0 150px;
    margin: 0 0 100px 0;
  }
  &__tile {
    display: flex;
    align-items: center;
    height: 150px;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    text-decoration: none;
    border: none;
    color: var(--white);
    &:hover {
      cursor: pointer;
      #{$this}__overlay {
        opacity: 1;
      }
    }
  }
  &__overlay {
    position: absolute;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.4)
    );
    z-index: 1;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__title-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    z-index: 2;
  }
  &__title {
    border-left: 5px solid var(--orange);
    padding: 0 0 0 20px;
    font-weight: 700;
    font-size: 1.5rem;
  }
}
</style>
